import React from "react";
import "../styles/Hero.css"; // adjust path if needed

const Hero = () => {
  return (
    <section id="hero" className="hero section">
      <h1>Welcome to Perfect Translation Services</h1>
      <p>Your trusted partner for accurate and professional translations.</p>
      <a href="#quote" className="btn">Get A Free Quote</a>
    </section>
  );
};

export default Hero;
